import { useCallback, useContext } from 'react';
import { useGetEvents } from 'lib/api/event';
import { AuthContext } from "App"

import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IEventHome } from 'interfaces'
import CircularProgressBox from 'components/utils/CircularProgressBox'
import { formatNumber } from 'lib/common/string.helper'

const TextTitle = styled(Typography)({
    fontWeight: 400,
    fontSize: '1.8rem',
    "@media (orientation: landscape)": {
        marginLeft: '6rem',
        zoom: 0.75,
    },
});

const TextDescription = styled(Typography)({
    marginTop: '0',
    fontWeight: 700,
    fontSize: '3.3rem',
    "@media (orientation: landscape)": {
        marginLeft: '6rem',
        zoom: 0.75,
    },
});

const BoxMain = styled(Box)({
    typography: "body1",
    margin: "0 auto",
    paddingTop: "3rem",
    "@media (orientation: landscape)": {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        alignItems: "center",
        padding: "0rem",
        height: "100%",
    },
});

export default function UserWashBottle() {
    const { user } = useContext(AuthContext)
    const { data, isLoading } = useGetEvents(user?.data?.id, 10)

    const currentEvent: () => IEventHome | null = useCallback(() => {
        const currentData = data?.data?.find(e => e.code.includes('all'))
        if (currentData?.id) {
            return currentData
        } else
            return null
    }, [data?.data])

    const BoxAvatar = styled(Box)(() => ({
        width: "100%",
        paddingBottom: "100%",
        backgroundImage: `url(${currentEvent()?.image.value})`,
        backgroundSize: "100%",
        backgroundPosition: "center",
        marginBottom: "2rem",
        "@media (orientation: landscape)": {
            position: "relative",
            boxShadow: "0 0 15px 10px rgba(0, 0, 0, 0.07)",
            marginBottom: "0rem",
        },
    }));
    
    return (
        <>
            {
                isLoading ? (
                    <CircularProgressBox />
                ) : !!data?.data?.length && (
                    <BoxMain>
                        <BoxAvatar />
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {
                                currentEvent()?.content?.map((content, index) => (
                                    <Box key={`${content}-${index}`}>
                                        <TextTitle paddingTop={index === 0 ? '2rem' : '1rem'} align='center'>{content.title}</TextTitle>
                                        <TextDescription align='center'>{formatNumber(content.value)}{content.unit}</TextDescription>
                                    </Box>
                                ))
                            }
                        </Box>
                    </BoxMain>
                )
            }
        </>
    );
}